/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Component, FormEvent, MouseEvent } from 'react';
import { AppState } from '../../app.state';
import { User, _User } from '../../_shared/interfaces/user';
import { Alert, message } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router';
import FormTitle from '../../_shared/form-title';
import styles from './mfa-settings.styles';
import { Button } from '../../_shared/button';
import { ModalVerify } from '../../_shared/modal-verify';
import { get, set } from 'lodash';
import { _ModalVerify } from '../../_shared/modal-verify/modal-verify.component';
import { WithForm } from '../../_shared/form';
import { stopProp } from '../../utils';

interface IProps extends RouteComponentProps {
  sState: AppState;
  updateUser: (user: User, shouldUpdateCurrent?: boolean) => Promise<User>;
  form?: any;
}

export class _MFASettings extends Component<IProps> {
  state = {
    loading: false,
    toDisplay: [
      {
        title: 'Multi Factor Authentication',
        var: 'mfa',
        type: 'radio',
        vals: ['email', 'sms'],
      },
    ],
  };

  submit = async (e: MouseEvent | FormEvent) => {
    stopProp(e);
    if (this.state.loading) {
      return;
    }
    const me: any = get(this.props, 'sState.auth.user');
    this.state.loading = true;
    this.setState(this.state);

    this.props.form.validateFieldsAndScroll(async (err: any, values: any) => {
      if (err) {
        message.error(err);
        return this.setState({ loading: false });
      }

      try {
        const {
          sState: { auth },
        } = this.props;

        const ouser = new _User({
          ...auth.user,
        } as User);
        const user = new _User({
          ...auth.user,
        } as User);

        this.state.toDisplay.map(item => {
          const val = values[item.var];
          user[item.var] = val;
        });

        if (user.mfa === 'sms' && ouser.mfa !== 'sms') {
          const mverify = get(this, 'MODALVERIFY');
          const valid =
            mverify &&
            mverify.openModal &&
            (await mverify.openModal({
              phone: user.phone,
            }));
          // AER-1628: only overwrite phone/verified when the modal actually
          // returned a phone. If the user cancelled, or the modal was
          // unavailable, keep the original phone — do NOT wipe it.
          const newPhone = get(valid, 'phone');
          if (newPhone) {
            set(user, 'phone', newPhone);
            set(user, 'phoneVerified', true);
          }
        }
        const shouldUpdateCurrent = me.userId === user.userId;
        await this.props.updateUser(user, shouldUpdateCurrent);
        message.success('Data saved successfully!');
        this.setState({
          loading: false,
          isEdit: false,
        });
      } catch (err) {
        message.error('Save failed: ' + err.message);
        return this.setState({
          loading: false,
        });
      }
    });
  };
  componentDidMount = () => {
    this.setFieldsOriginal();
  };
  setFieldsOriginal = () => {
    const { toDisplay } = this.state;
    const {
      sState: {
        auth: { user },
      },
      form: { setFieldsValue },
    } = this.props;

    const User = new _User({
      ...user,
    } as User);

    if (!User.mfa) {
      User.mfa = 'email';
    }

    toDisplay.map(item => {
      setFieldsValue({ [item.var]: User[item.var] });
    });
  };
  MODALVERIFY: _ModalVerify | undefined;
  render() {
    const {
      sState: {
        auth: { user },
      },
      form: { Form }
    } = this.props;
    const { toDisplay, loading } = this.state;

    return user ? (
      <div css={css(styles.container)}>
        <FormTitle title={`2 Factor Authentication Preference`} />

        <div css={css(styles.colContainer)}>
          <span css={css(styles.col1)}>Notification Type</span>
          <span css={css(styles.col2)}>Email</span>
          <span css={css(styles.col3)}>SMS</span>
        </div>

        <Form
          layout="vertical"
          onSubmit={this.submit}
          items={toDisplay}
        >
          <Button title={'Save'} loading={loading} onClick={this.submit} />
        </Form>

        <ModalVerify
          wrappedComponentRef={(comp: _ModalVerify) =>
            set(this, 'MODALVERIFY', comp)
          }
        />
      </div>
    ) : (
      <div>No User Provided</div>
    );
  }
}

export const MFASettings = WithForm(withRouter(_MFASettings));
